import { DateTime } from 'luxon'

import { TimeStepCumulativeRainfallDTO } from '@/api/core/dto/snapshot/TimeStepCumulativeRainfallDTO'

import { ITimeAndCityLocalizable } from '@/model/ITimeAndCityLocalizable'
import { TimeStepCumulativeRainfall } from '@/model/TimeStepCumulativeRainfall'
import { CumulativeRainfallIntensityFactory } from '@/model/CumulativeRainfallIntensityFactory'

export class TimeStepCumulativeRainfallFactory {
  static createEmpty(snapshot: ITimeAndCityLocalizable, timestamp: DateTime): TimeStepCumulativeRainfall {
    return new TimeStepCumulativeRainfall(snapshot, timestamp, new Map())
  }

  static fromDTO(dto: TimeStepCumulativeRainfallDTO, snapshot: ITimeAndCityLocalizable): TimeStepCumulativeRainfall {
    return new TimeStepCumulativeRainfall(
      snapshot,
      DateTime.fromISO(dto.timestamp, { zone: 'UTC' }),
      dto.cumulativeTimeAndIntensity
        ? new Map(
            dto.cumulativeTimeAndIntensity.map((cti) => [
              cti.cumulativeRainfall,
              CumulativeRainfallIntensityFactory.fromDTO(cti),
            ]),
          )
        : new Map(),
    )
  }
}
